import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import cookieClient from 'react-cookies';
import fetcher from "@/common/axiosInstance";
import useLocalStorage from "@hooks/useLocalStorage";
export var api__getIsWorkingTime = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var _ref2, _res$data;
    var _useLocalStorage, setLocalStorage, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _useLocalStorage = useLocalStorage(), setLocalStorage = _useLocalStorage.setLocalStorage;
          _context.n = 1;
          return fetcher().get("/site/check-working-time?hour=".concat(new Date().getHours()));
        case 1:
          res = _context.v;
          if (__IS_CSR__ && res.headers['x-country-code']) {
            setLocalStorage('country_code', res.headers['x-country-code']);
            // un-encrypted cookie for parsing in gtm
            cookieClient.save('country_code', res.headers['x-country-code']);
          }
          return _context.a(2, (_ref2 = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data.is_working_time) !== null && _ref2 !== void 0 ? _ref2 : true);
      }
    }, _callee);
  }));
  return function api__getIsWorkingTime() {
    return _ref.apply(this, arguments);
  };
}();